<span>
    {{ value | formatValue: unit: formatValueOptions }}
</span>
